module.exports = __webpack_public_path__ + "static/media/siddharth-salem-trip-05.1a6295c9.png";